async function checkDeviceType(authCode: string) {
  const url = `/api/v1/app-sign-in/type/?authCode=${authCode}`
  const response = await fetch(url)
  const json = await response.json()
  return json
}

async function registerToUser(authCode: string, deviceType: string, uid: string) {
  const url = `/api/v1/app-sign-in/${uid}/?authCode=${authCode}&deviceType=${deviceType}`
  const response = await fetch(url, { method: 'POST' })
  const json = await response.json()
  return json
}

function getDeviceName(deviceType: string) {
  switch(deviceType.toLowerCase()) {
    case "tvos":
      return "Apple TV"
    case "amazon os tv":
      return "Fire TV"
    case "vizio tv":
      return "VIZIO TV"
    case "comcast x1":
      return "Comcast Device"
    default:
      return deviceType
  }
}

export {
  checkDeviceType,
  getDeviceName,
  registerToUser
}
